import React, { useState, useEffect, useCallback, useRef } from 'react';
import './generate-doc.scss';
import TabPanel from 'devextreme-react/tab-panel';
import { HtmlEditor, Toolbar, Item, } from 'devextreme-react/html-editor';
import { Button } from 'devextreme-react/button';
import {generate, getTemplateById} from '../../api/api'
import { useAuth } from '../../contexts/auth';
import notify from 'devextreme/ui/notify';
import { jsPDF } from 'jspdf';
import html2canvas from "html2canvas";
import { useNavigate, useParams } from 'react-router-dom';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import { Form, Label, SimpleItem, RequiredRule, ButtonItem
} from 'devextreme-react/form';

const sizeValues = [ "8pt", "10pt", "12pt", "14pt", "18pt", "24pt", "36pt" ];
const fontValues = [ "Arial", "Georgia", "Tahoma", "Times New Roman", "Verdana" ];
const headerValues = [ false, 1, 2, 3, 4, 5 ];
const sleep = ms => new Promise(r => setTimeout(r, ms));

const downloadImage = (blob, fileName) => {
  const fakeLink = window.document.createElement("a");
  fakeLink.style = "display:none;";
  fakeLink.download = fileName;

  fakeLink.href = blob;

  document.body.appendChild(fakeLink);
  fakeLink.click();
  document.body.removeChild(fakeLink);

  fakeLink.remove();
};

const exportAsImage = async (el, imageFileName) => {
  const canvas = await html2canvas(el);
  const image = canvas.toDataURL("image/png", 1.0);
  downloadImage(image, imageFileName);
  // download the image
};

export default function GenerateDoc() {
  const { user, refreshSession } = useAuth();
  let { template_id } = useParams();
  const navigate = useNavigate();

  const editorRef = useRef(null);
  const exportRef = useRef();
  const formRef = useRef(null);
  const tabsRef = useRef(null);

  const [htmlData, setHtmlData] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [qa, setQA] = useState({});
  const [loading, setLoading] = useState(true);
  const [generating, setGenerating] = useState(false);
  const [html2Render, setHtml2Render] = useState([]);
  const [renderedHTML, setRenderedHTML] = useState(null);
  const [printing, setPrinting] = useState(false);


  const onValueChanged = (e) => {
    setHtmlData(e.value)
  }

  const onPrint = useCallback(() => {
    //console.log(exportRef.current.offsetHeight);
    //let data = htmlData.split("{{{PAGE_BREAK}}}")
    //console.log(data);
    //console.log(exportRef.current);
    /*for (var i=0; i<exportRef.current.length; i++) {
      if (exportRef.current[i]) {
        exportAsImage(exportRef.current[i], "test")
      }
    }*/

    setPrinting(true);
    //setHtml2Render(data);
    /*var doc = new jsPDF()
    //doc.text('Hello world!', 10, 10)
    doc.html(htmlData, {
       callback: function (doc) {
         doc.save('a4.pdf');
       }
    });
    //doc.save()*/
  }, [htmlData, exportRef, setHtml2Render])


  /*useEffect(() => {
    console.log(exportRef.current)
    if (!printing) {
      console.log("not printing");

    } else {
      console.log("printing");
      if (exportRef.current) {
        setPrinting(false);
      }

    }
  }, [printing, exportRef]);
  */

  const handlePrintRender = useCallback((node) => {
    for (var i=0; i<node?.children.length; i++) {
      if (node?.children[i]) {
        console.log(node?.children[i]);
        exportAsImage(node?.children[i], "test")
      }
    }
    setPrinting(false);
    //setElementRect(node?.getBoundingClientRect());
  }, []);

  /*useEffect(() => {
    console.log(html2Render);
    console.log(exportRef.current);

  }, [html2Render, exportRef.current]);

  useEffect(() => {
    console.log(renderedHTML);
  }, [renderedHTML]);

  useEffect(() => {
    console.log(exportRef.current);
    for (var i=0; i<exportRef.current.length; i++) {
      if (exportRef.current[i]) {
        exportAsImage(exportRef.current[i], "test")
      }
    }


  }, [exportRef.current]);*/

  const onSuccess = useCallback((data) => {
    tabsRef.current.instance().option("selectedIndex",1);
    setGenerating(false);
    console.log("Done generating");
    setHtmlData(data);
  }, [])

  const onError = useCallback((error) => {
    if (error.status === 401) {
      refreshSession();
    } else {
      notify("An error has occured. Please try again later.", 'error', 2000);
      setLoading(false);
      setGenerating(false);
      console.log(error);
    }
  }, [refreshSession]);

  const generateDoc = useCallback(() => {
    setGenerating(true);
    tabsRef.current.instance().option("selectedIndex",1);
    var data = {}
    data['qa'] = Object.keys(qa).map((key) => {return {"question":key, "answer":qa[key]}});
    data['template_id'] = template_id
    generate(user, data, onSuccess, onError);
  }, [qa, template_id, user, onSuccess, onError])

  const onTemplateDataSuccess = useCallback((data) => {
    setQuestions(data.questions)
    setLoading(false);
  }, [])

  useEffect(() => {
    if (user.signInUserSession) {
      getTemplateById(user, template_id, onTemplateDataSuccess, onError)
    }
  }, [user, template_id, onTemplateDataSuccess, onError]);

  const onFormDataChanged = useCallback((e) => {
    qa[e.dataField]=e.value
    setQA(qa)
  }, [qa, setQA])

  const onTabClick = (e) => {
    if ((htmlData === null) && (generating === false)) {
      notify("Please generate a document first by answering the questions and then pressing generate.", 'warning', 5000);
    }
  }

  const onTabChanging = (e) => {
    if ((e.addedItems.length) && (e.addedItems[0].title === "Generated Document")) {
      if ((htmlData === null) && (generating === false)) {
        e.cancel=true
      }
    }
  }
  /*
  const TabPanelItem = ({ data }) => {
    console.log("TabPanelItem");
    console.log(data);
    return <div className="tabpanel-item" style={{maxHeight:"72vh"}}>{
      generating?
      <div style={{minHeight:"72vh"}}>
        <div className="d-flex flex-row justify-content-center align-items-center pt-5 pb-5">
          Please wait. This may take up to 1 minute...
        </div>
        <div className="d-flex flex-row justify-content-center align-items-center">
            <LoadIndicator
                id="large-indicator"
                height={60}
                width={60}
            />
        </div>
      </div>
      :
      data.children}</div>;
  }*/

  const TabPanelItem = ({ data }) => {
    return <div className="tabpanel-item" style={{maxHeight:"72vh"}}>{data.children}</div>;
  }

  const tabs = [
    {
      title: 'Template Questions',
      icon: "fab fa-wpforms",
      children: (
        <div className="p-3" style={{height:"73vh", overflowY:"scroll"}}>
          <Form
            ref={formRef}
            id={'form'}
            formData={qa}
            onFieldDataChanged={onFormDataChanged}
            labelMode="floating"
          >
            {questions.map((item) => (
              <SimpleItem
                key={item}
                dataField={item}
              >
                <Label text={item}/>
                <RequiredRule message="Answer is required" />
              </SimpleItem>
            ))}
            <ButtonItem buttonOptions={{
              text: 'Generate',
              type: 'default',
              onClick: generateDoc,
              width: '120px',
            }} />
          </Form>
        </div>
        )
    },
    {
      title: 'Generated Document',
      icon: "far fa-file-alt",
      children: (
        <div className="" style={{height:"73vh"}}>
        <HtmlEditor
          ref={editorRef}
          onValueChanged={onValueChanged}
          value={htmlData}
          height="100%"
        >
          <Toolbar multiline={true}>
            <Item name="undo" />
            <Item name="redo" />
            <Item name="separator" />
            <Item name="size" acceptedValues={sizeValues} />
            <Item name="font" acceptedValues={fontValues} />
            <Item name="separator" />
            <Item name="bold" />
            <Item name="italic" />
            <Item name="strike" />
            <Item name="underline" />
            <Item name="separator" />
            <Item name="alignLeft" />
            <Item name="alignCenter" />
            <Item name="alignRight" />
            <Item name="alignJustify" />
            <Item name="separator" />
            <Item name="orderedList" />
            <Item name="bulletList" />
            <Item name="separator" />
            <Item name="header" acceptedValues={headerValues} />
            <Item name="separator" />
            <Item name="color" />
            <Item name="background" />
            <Item name="separator" />
            <Item name="link" />
            <Item name="image" />
            <Item name="separator" />
            <Item name="clear" />
            <Item name="codeBlock" />
            <Item name="blockquote" />
            <Item name="separator" />
          </Toolbar>
        </HtmlEditor>



      </div>)
    },
    {
      title: 'Print',
      icon: "fas fa-print",
      children: (
        <div className="" style={{height:"73vh"}}>
        <Button
          onClick={onPrint}
          text="Print"
        />
        {true&&<div ref={handlePrintRender}>
          {htmlData?.split("{{{PAGE_BREAK}}}").map(item => (
           <div className="dx-card" key="0" dangerouslySetInnerHTML={{ __html: item }}/>
          ))}
        </div>}



      </div>)
    },
  ];

  return (
    <React.Fragment>
      {loading?
      <div className="d-flex flex-row justify-content-center align-items-center mt-5 pt-5">
          <LoadIndicator
              id="large-indicator"
              height={60}
              width={60}
          />
      </div>
      :
      <div className="d-flex flex-column">
        <div className="d-flex flex-row justify-content-between align-items-end">
          <div className="pe-3" style={{minWidth:"60%"}}>
            <h2 className={'content-block'}>Generate Document</h2>
          </div>
          <Button
              text="Cancel"
              icon="fas fa-chevron-left"
              onClick={() => {navigate("/templates")}}
          />
        </div>
        <hr/>
        <div className="dx-card">
          <TabPanel
            ref={tabsRef}
            width="100%"
            height={"auto"}
            swipeEnabled={true}
            dataSource={tabs}
            tabsPosition={'left'}
            stylingMode={'secondary'}
            iconPosition={'left'}
            itemComponent={TabPanelItem}
            onTitleClick={onTabClick}
            onSelectionChanging={onTabChanging}

            animationEnabled={false}
          />
        </div>
      </div>}

    </React.Fragment>
)}
